import React from "react";
import { RideGrid } from "@rimac-seguros/ride-system-components";
import heroImage from "@/assets/imagen-principal.png";
import Form from "../Form/index";
import { RideGlArrowBack, RideIconButton } from '@rimac-seguros/ride-system-components'
import useEmbeddedNavigation from "../../hooks/useEmbeddedNavigation";
import "./styles.scss";

const SectionHero = (props) => {
  const { title, subtitle } = props;

  const { originEmbedded, handleClickBack } = useEmbeddedNavigation();

  return (
    <div className={`section-hero${originEmbedded ? "--embedded" : ""}`}>
      <RideGrid>
        {originEmbedded && (
          <RideIconButton
            glyph={<RideGlArrowBack />}
            variant='unfill'
            size='large'
            onClick={handleClickBack}
          />
        )}
        <div className="section-hero_img">
          <img src={heroImage} alt="imagen del hero" />
        </div>
        <div className="section-hero_title">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        <Form {...props} />
      </RideGrid>
    </div>
  );
};

export default SectionHero;
